import { motion } from 'framer-motion';

export const PolitiqueConfidentialite = () => {
  return (
    <div data-testid="politique-confidentialite-page" className="min-h-screen pt-20 bg-[#0a0908]">
      <div className="max-w-4xl mx-auto px-6 sm:px-12 py-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="font-heading text-4xl sm:text-5xl font-light text-[#fdfbf7] mb-12">
            Politique de confidentialité
          </h1>
          
          <div className="space-y-8 text-[#a39c93] font-body leading-relaxed">
            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Collecte des données</h2>
              <p>
                Ce site ne collecte aucune donnée personnelle automatiquement. 
                Aucun cookie de traçage n'est utilisé sur ce site.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Données de contact</h2>
              <p>
                Si vous nous contactez par téléphone ou par email, vos coordonnées seront 
                utilisées uniquement pour répondre à votre demande et ne seront jamais 
                transmises à des tiers sans votre consentement.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Vos droits</h2>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), 
                vous disposez d'un droit d'accès, de rectification, de suppression et 
                de portabilité de vos données personnelles.
              </p>
              <p className="mt-4">
                Pour exercer ces droits, vous pouvez nous contacter à l'adresse : 
                contact@rozier-menuiserie.fr
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Hébergement des données</h2>
              <p>
                Les données éventuellement collectées sont hébergées en France/Europe, 
                conformément aux exigences du RGPD.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-[#fdfbf7] mb-4">Modification de la politique</h2>
              <p>
                Nous nous réservons le droit de modifier cette politique de confidentialité 
                à tout moment. Les modifications prendront effet dès leur publication sur cette page.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
